module.exports = __webpack_public_path__ + "img/SKMJ_line2.f18b3094.jpg";